import React from "react";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {Container} from "react-bootstrap";
import {mygaSession} from "../../../scripts/myga-session";
import {APP_SECTION} from "../../../scripts/constants";
import {saveApplication} from "../../../scripts/sync-manager";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";

class FundsFL extends React.Component {

  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      errorMessage: '',
      funds: {...mygaSession.getCurrentAppFunds()}
    };

  }

  validate = () => {
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finances_ErrorMissingInformation
      });
      return false;
    }

    return true;
  };

  saveApplication = async () => {
    // populate finance object from fields
    let funds = this.state.funds;

    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.funds,funds);

    await saveApplication(APP_SECTION.funds)
  };

  handleChange = (field) => (e) => {
    let funds = this.state.funds;
    funds[field] = e.target ? e.target.value : e;

    this.setState({
      funds: funds,
      errorMessage:'',
    });
  };

  render() {
    return (
      <AppContentWrapper
        onBackPressed={this.saveApplication}
        onNextPressed={this.saveApplication}
        validateOnNext={this.validate}
        updatePage={this.props.updatePage}
        errorMessage={this.state.errorMessage}>

        <form className={'needs-validation'}
              ref={(form) => {
                this.pageForm = form;
              }}>
          <Container className={'pt-5 pl-5'}>
            <Question
              containerClass={'pb-4'}
              question={PageManager.getQuestionByName('penaltyFreeAccessFL')}
              data={this.state.funds}
              onChange={this.handleChange}
            />
            {/*<Question*/}
            {/*  containerClass={'pb-4'}*/}
            {/*  question={PageManager.getQuestionByName('expectLumpSumPaymentsFL')}*/}
            {/*  data={this.state.funds}*/}
            {/*  onChange={this.handleChange}*/}
            {/*/>*/}
            {/*<Question*/}
            {/*  containerClass={'pb-4'}*/}
            {/*  question={PageManager.getQuestionByName('replacementFL')}*/}
            {/*  data={this.state.funds}*/}
            {/*  onChange={this.handleChange}*/}
            {/*/>*/}
            <Question
              containerClass={'pb-4'}
              question={PageManager.getQuestionByName('hasReverseMortgageFL')}
              data={this.state.funds}
              onChange={this.handleChange}
            />
            <Question
              containerClass={'pb-4'}
              question={PageManager.getQuestionByName('additionalInfoFL')}
              data={this.state.funds}
              onChange={this.handleChange}
            />
          </Container>
        </form>

      </AppContentWrapper>
    )
  }
}

export default FundsFL